import React, { Component, Fragment } from 'react'
import CategorySelector from './CategorySelector/'
import SlugPreview from './SlugPreview'
import TinyEditor from 'components/TinyEditor'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from 'modules/knowledgebase/actions'

import miniDeleteCategoryIcon from 'images/mini_delete_article_icon.svg'
import { getArticle, getCategories } from 'modules/knowledgebase/selectors'
import { getCanonicalDomain } from 'modules/settings/selectors'

import './style.css'

const LOCAL_DEBUG = false

class Editor extends Component {
  componentDidMount() {
    if (!this.props.isEditing) {
      this.props.actions.clearArticle()
    }
  }
  
  componentWillUnmount() {
    this.props.actions.clearArticle()
  }

  setSlug = value => {
    const { actions } = this.props
    actions.setSlug(value)
  }
  
  handleEditorChange = value => {
    const { actions } = this.props
    actions.setDocument(value)
  }

  render() {
    if (!this.props.categories.length) return null
    
    const { categories, article, hostName } = this.props
    const articleCatId = article.categoryId || categories[0].id
    const selectedCategory = categories.find(c => c.id === articleCatId)

    return (
      <Fragment>
        {LOCAL_DEBUG &&
          <div className="article-editor-bar">
            <SlugPreview
              hostName={hostName}
              slug={article.slug}
              setSlug={this.setSlug}
            />
            <div className="article-editor-bar-right">
              <span>Located In:</span>
              <CategorySelector
                selectedCategory={selectedCategory}
                article={article}
                articleCatId={articleCatId}
              />
              <button
                disabled={!this.props.isEditing}
                className="article-editor-bar-article-delete"
                onClick={this.props.onDeleteArticleClick}
              >
                <img
                  src={miniDeleteCategoryIcon}
                  alt="Delete article icon"
                />
              </button>
            </div>
          </div>
        }
        <div className="editor-wrapper">
          <div className="tiny-editor-wrapper">
            <TinyEditor article={article} onEditorChange={this.handleEditorChange} />
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  article: getArticle(state),
  categories: getCategories(state),
  hostName: getCanonicalDomain(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setSlug: actions.setSlug,
    setDocument: actions.setDocument,
    clearArticle: actions.clearArticle
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
